import _map from 'lodash/map';
import React, { memo } from 'react';
import { IRecommendProduct } from '../api-helpers/trending-api';

interface IProps {
  products: IRecommendProduct[];
  title?: string;
  isRecommendProducts?: boolean;
  onClickLink?: () => void;
  isLightbox?: boolean;
}

const ProductRecommendation: React.FC<IProps> = ({ products, title = 'Trending Now', isRecommendProducts, onClickLink, isLightbox = false }) => {
  return (
    <div className='flex flex-col'>
      <div className={`font-bold mb-4 sm:mb-6 lg:mb-8 flex justify-between items-center font-heading ${isLightbox ? 'text-card-headline' : 'text-trending-title '}`}>
        <div>{title}</div>
        {
          onClickLink && <div onClick={onClickLink} className='text-16 text-jm-gray-sub-content underline cursor-pointer'>See More</div>
        }
      </div>
      <div className={`text-jm-gray-content ${isRecommendProducts ? 'grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 lg:gap-6' : 'flex space-x-3 sm:flex-col sm:space-y-5 sm:space-x-0 lg:flex-row lg:space-y-0 lg:space-x-2'}`}>
        {
          _map(products, (product: IRecommendProduct, index: number) => (
            <a className='flex-1 flex flex-col' key={index} href={product.url} target='_blank' rel='noreferrer' >
              <>
                <img src={product.photo} alt='product' />
                <div className='mt-3 flex-grow'>
                  <span className='font-bold uppercase'>{product.brand}</span>
                  <span className='sm:ml-1 block sm:inline overflow-hidden text-ellipsis'>{product.name}</span>
                </div>
                <div className='mt-2 font-bold'>{product.price}</div>
              </>
            </a>
          ))
        }
      </div>
    </div>
  )
};

export default memo(ProductRecommendation);
